export const ChargeSupplyDayConstants = {
  SupplyDays: "充電電力量（日別）",
  OfficeName: "会社／営業所",
  TargetDate: "対象年月",
  TargetDatetime: "対象年月日",
  ChargeElectricPower: "充電電力量（kWh）",
  ChargeElectricPowerSum: "合計充電電力量（kWh）",
} as const;
